module.exports = __webpack_public_path__ + "img/logo_OTC.c4f3d28d.png";